import { ProductCatalogEmbroideryTypes } from '../../../__generated__/graphql/catalog/graphql'
import { EmbroideryFormKind } from '../types'

const b2bFormKindByType = {
  ICON: ['ICON'],
  TEXT: ['TEXT'],
  LOGO: ['LOGO_B2B'],
} as const satisfies Record<ProductCatalogEmbroideryTypes, EmbroideryFormKind[]>

const dtcFormKindByType = {
  ICON: ['ICON'],
  TEXT: ['TEXT'],
  LOGO: ['LOGO_SETUP', 'LOGO_DTC'], // If there are multiple in this list, the first should be the "landing page" form for this type of embroidery.
} as const satisfies Record<ProductCatalogEmbroideryTypes, EmbroideryFormKind[]>

const typesByFormKind = {
  ICON: 'ICON',
  LOGO_B2B: 'LOGO',
  LOGO_DTC: 'LOGO',
  TEXT: 'TEXT',
  LOGO_SETUP: 'LOGO',
} as const satisfies Record<EmbroideryFormKind, ProductCatalogEmbroideryTypes>

type Props = {
  embroideryType: ProductCatalogEmbroideryTypes | undefined | null
  isB2b: boolean
}

export function getFormsForEmbroideryType({ embroideryType, isB2b }: Props): EmbroideryFormKind[] {
  if (!embroideryType) return []
  if (isB2b) {
    return b2bFormKindByType[embroideryType]
  } else {
    return dtcFormKindByType[embroideryType]
  }
}

export function getInitialFormForEmbroideryType(props: Props): EmbroideryFormKind {
  return getFormsForEmbroideryType(props)[0]!
}

// gets the last item in the formKindByType arrays - the last item in those arrays is the "submitting"
// form, meaning the last page of their respective embroidery selection wizards.
export function getSubmissionFormForEmbroideryType(props: Props): EmbroideryFormKind | undefined {
  const forms = getFormsForEmbroideryType(props)
  return forms[forms.length - 1]
}

export const getEmbroideryTypeForEmbroideryForm = (
  formKind: EmbroideryFormKind
): ProductCatalogEmbroideryTypes => {
  return typesByFormKind[formKind]
}

// Embroidery types that are mutually exclusive — only one of a conflicting pair can be added
// to the bag at a time.
const conflictingEmbroideryTypeByType: Partial<
  Record<ProductCatalogEmbroideryTypes, ProductCatalogEmbroideryTypes>
> = {
  LOGO: 'ICON',
  ICON: 'LOGO',
}

export const getConflictingEmbroideryType = (
  embroideryType: ProductCatalogEmbroideryTypes
): ProductCatalogEmbroideryTypes | null => {
  return conflictingEmbroideryTypeByType[embroideryType] ?? null
}
